/**
 * 店铺一览画面 - Action Creators
 */

import * as types from './shopListActionTypes';
import { SearchParams, FilterState, Shop, FilterOption, AreaOption } from '../../../pages/ShopList/types';

// 设置搜索参数
export const setSearchParams = (params: SearchParams) => ({
  type: types.SET_SEARCH_PARAMS,
  payload: params,
});

// 设置筛选条件
export const setFilters = (filters: FilterState) => ({
  type: types.SET_FILTERS,
  payload: filters,
});

// 清除筛选条件
export const clearFilters = () => ({
  type: types.CLEAR_FILTERS,
});

export const fetchShopsRequest = () => ({
  type: types.GET_VISITOR_CLUB_LIST_REQUEST,
});

export const fetchShopsSuccess = (shops: Shop[], totalCount: number) => ({
  type: types.GET_VISITOR_CLUB_LIST_SUCCESS,
  payload: { shops, totalCount },
});

export const fetchShopsFailure = (error: string) => ({
  type: types.GET_VISITOR_CLUB_LIST_FAILURE,
  payload: error,
});

export const fetchShopsInitial = () => ({
  type: types.GET_VISITOR_CLUB_LIST_INITIAL,
});

export const getVisitorClubOptionsListRequest = () => ({
  type: types.GET_VISITOR_CLUB_OPTIONS_LIST_REQUEST,
});

export const getVisitorClubOptionsListSuccess = (
  areaOptions: AreaOption[],
  facilityOptions: FilterOption[],
  serviceOptions: FilterOption[],
) => ({
  type: types.GET_VISITOR_CLUB_OPTIONS_LIST_SUCCESS,
  payload: { facilityOptions, areaOptions, serviceOptions },
});

export const getVisitorClubOptionsListFailure = (error: string) => ({
  type: types.GET_VISITOR_CLUB_OPTIONS_LIST_FAILURE,
  payload: error,
});

export const getVisitorClubOptionsListInitial = () => ({
  type: types.GET_VISITOR_CLUB_OPTIONS_LIST_INITIAL,
});
